// extracted by mini-css-extract-plugin
export default {"arrowButton":"NegotiationCell_arrowButton__k9tLJ","expanded":"NegotiationCell_expanded__Ma1No","icon":"NegotiationCell_icon__X3rw7"};